export default __webpack_public_path__ + "static/media/video9.0f2d85b5.webp";